import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './admin.routes';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura'; 

export const adminAppConfig: ApplicationConfig = {
  providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideAnimations(),
        providePrimeNG({
            theme: {
                preset: definePreset(Aura, {
                  // Override semantic tokens
                  semantic: {
                    primary: {
                      50: '{indigo.50}',
                      100: '{indigo.100}',
                      200: '{indigo.200}',
                      300: '{indigo.300}',
                      400: '{indigo.400}',
                      500: '{indigo.500}', // This will be your main primary color
                      600: '{indigo.600}',
                      700: '{indigo.700}',
                      800: '{indigo.800}',
                      900: '{indigo.900}',
                      950: '{indigo.950}',
                    },
                  },
                }),
                
                options: { 
                  darkModeSelector: 'none' // This is the key
                }                
            }
        }),      
        provideRouter(routes)
    ]
};
